export const SET_RATINGS_LOADING = "SET_RATINGS_LOADING";
export const SET_RATINGS_DETAILS = "SET_RATINGS_DETAILS";
// export const SET_RATINGS_RECORDING_URL = "SET_RATINGS_RECORDING_URL";
